interface IBannerAlert {
    onCloseClickCallback: () => void;
    warnings: Immutable.List<string>;
}

class BannerAlert extends React.Component<IBannerAlert, never> {
    public render(): JSX.Element {
        return (
            <div id="___bdrg001" className="warnings-collection-container">
                <div className="hd">
                    <span className="glyphicon glyphicon-remove pull-right" onClick={this.hideWarnings.bind(this)} />
                    <label>{cacheStore.GetString("AlertLabel")}</label>
                </div>
                <div className="w-col">
                    {this.props.warnings.map((w: string, k: number) => (
                        <p key={k + "_w"}>{cacheStore.GetString(w)}</p>
                    ))}
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        var opt: JQueryUI.DraggableOptions = {
            handle: "div.hd"
        };
        $("#___bdrg001").draggable(opt);
    }

    public componentWillUnmount(): void {
        $("#___bdrg001").draggable("destroy");
    }

    private hideWarnings(): void {
        this.props.onCloseClickCallback();
    }
}

export { BannerAlert };
